'use client';

import { useEffect, useState } from 'react';
import { HeroPhoneRotator } from './hero-phone-rotator';

interface IHeroVideoBehaviorProps {
  children: React.ReactNode;
}

export function HeroVideoBehavior({ children }: IHeroVideoBehaviorProps): React.JSX.Element {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    const video = document.querySelector<HTMLVideoElement>('[data-hero-video]');
    if (!video) {
      return;
    }
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      video.pause();
    }
    const handleError = (): void => setFailed(true);
    video.addEventListener('error', handleError);
    return (): void => {
      video.removeEventListener('error', handleError);
    };
  }, []);

  if (failed) {
    return <HeroPhoneRotator />;
  }
  return <>{children}</>;
}
